export { default as AnimalPrint } from './AnimalPrint'
